import axios from 'axios'

import authService from './authService'

const isTransientNetworkError = (error) => {
  const message = String(error?.message || '')
  return (
    error?.code === 'ERR_NETWORK' ||
    message.includes('ERR_NETWORK_CHANGED') ||
    message.includes('Network Error')
  )
}
//RESOLVER POR QUE NO ESTA TOMANDO EL localhost:5001 cuando lo intento traer desde SERVER_BACK_ADDR, lo mismo con las variables de keycloak en authService.js
const api = axios.create({
// baseURL desde entorno (Vite expone solo variables con prefijo VITE_)
  baseURL: import.meta.env.VITE_SERVER_BACK_ADDR || 'http://localhost:5001',
})

// Interceptor: añade Authorization header con JWT si existe
api.interceptors.request.use((reqConfig) => {
  const token = authService.getAccessJWT()
  if (token !== 'no_token') {
    reqConfig.headers['Authorization'] = `Bearer ${token}`
  }
  return reqConfig
})

// Interceptor: manejo de errores globales
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config || {}
    const method = String(originalRequest.method || '').toLowerCase()

    // Retry idempotent reads once when the browser reports transient network switches.
    if (method === 'get' && isTransientNetworkError(error)) {
      originalRequest._retryCount = originalRequest._retryCount || 0
      if (originalRequest._retryCount < 1) {
        originalRequest._retryCount += 1
        await new Promise((resolve) => setTimeout(resolve, 250))
        return api.request(originalRequest)
      }
    }

    if (error.response?.status === 401) {
      authService.removeToken()
      window.location.href = '/logout'
    }
    return Promise.reject(error)
  }
)

export default api
